import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UsersService } from '../users.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlItem, UserRoleEnum } from 'src/app/models/frontend';
import { IUserDto } from 'src/app/models/backend';
import { take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserRole } from 'src/app/models/enums';

@Component({
  selector: 'app-update-users',
  templateUrl: './update-users.component.html',
  styleUrls: ['./update-users.component.scss']
})
export class UpdateUsersComponent {
  errors: string[] | null = null;
  eventForm: FormGroup

  isMobileUser: ControlItem[] = []
  isTestAccount: ControlItem[] = []

  userRole: ControlItem[] = []
  constructor(
    public userService: UsersService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr:ToastrService
  ) {
    this.userRole = UserRoleEnum
    this.LoadDDLisMobileUser()
    this.LoadDDLisTestAccountr()
  }

  ngOnInit() {
    this.userService.GetUserById(this.userService.id)
    .pipe(take(1))
    .subscribe({
      next: r => {
        this.SetValuetoForm(r)
      },
      error: e => this.errors = e.error?.errors || [e.error?.message]
    })
  }
  SetValuetoForm(user: IUserDto) {
    console.log(user)
    this.userService.id = null
    this.eventForm = this.fb.group({
      Id: [user.id],
      firstName: [user.firstName, [Validators.required, Validators.maxLength(100)]],
      lastName: [user.lastName, [Validators.required, Validators.maxLength(100)]],
      email: [user.email, [Validators.required, Validators.maxLength(100)]],
      password: [user.password, [Validators.required, Validators.maxLength(100)]],
      mobileNumber: [user.mobileNumber, [Validators.required, Validators.maxLength(100)]],
      roleType:[user.roleType],
      DeviceId :[user.DeviceId],
      OTPNumber :[user.oTPNumber],
      StripeCustomerId :[user.StripeCustomerId],
      IsActive: true
    });
    console.log(this.eventForm)
  }
  onSubmit() {
    const roleTypeNumber = parseInt("3", 10);
    var mobUser = this.eventForm.value.isMobileUser;
    var boolValueMob = (mobUser == this.eventForm.value.isMobileUser);
    var testAccount = this.eventForm.value.isTestAccount;
    var boolValueTest = (testAccount == this.eventForm.value.isMobileUser);
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();

    this.eventForm = this.fb.group({
      id: this.eventForm.value.Id,
      firstName: this.eventForm.value.firstName,
      lastName: this.eventForm.value.lastName,
      email: this.eventForm.value.email,
      password: this.eventForm.value.password,
      mobileNumber: this.eventForm.value.mobileNumber,
      roleType: UserRole.Employee,
      oTPNumber:"",
      deviceId:"",
      stripeCustomerId:"",
      IsActive: true
    })
    console.log(this.eventForm.value)
    this.userService.UpdateUser(this.eventForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Updated', '', 'success')
          this.toastr.success('Updated','Success')
          this.activeModal.close({ refresh: true });
        },
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error:e=>{
          if(e.error?.errors || [e.error?.message])
          {
            this.toastr.error('Oops!', e.error.message);
          }
          else{
            this.toastr.error('Oops!', "Something went wrong");
  
          }
        }
      })
  }

  LoadDDLisMobileUser() {

    this.isMobileUser.push({ label: "Yes", value: true })
    this.isMobileUser.push({ label: "No", value: false })
  }
  LoadDDLisTestAccountr() {

    this.isTestAccount.push({ label: "Yes", value: true })
    this.isTestAccount.push({ label: "No", value: false })
  }
}
